import { EventEmitter } from 'events';
import dispatcher from '../dispatcher';
import constants from '../constants';

class GeometryStore extends EventEmitter {
    constructor() {
        super()

        // Set default state
        this.geometry = null;
    }

    handleActions(action) {
        switch(action.type) {
            case constants.GEOMETRY_SET: {
                this.setGeometry(action.geometry);
                break;
            }
        }
    }

    getGeometry() {
        return this.geometry;
    }

    setGeometry(geometry) {
        this.geometry = geometry;
        this.emit('change');
    }
}

const geometryStore = new GeometryStore;
geometryStore.dispatchToken = dispatcher.register(geometryStore.handleActions.bind(geometryStore));

export default geometryStore;